import { z } from "zod";
export const DocumentationPageAnchor = z.object({
    blockId: z.string(),
    level: z.number(),
    text: z.string(),
});
